type DashboardGridProps = {
  cards?: JSX.Element[];
  buttons?: JSX.Element[];
};

const DashboardGrid = (props: DashboardGridProps) => {
  const groupedCards = props.cards?.reduce((acc, card, index, cards) => {
    if (index % 2 === 0) {
      acc.push(cards.slice(index, index + 2));
    }
    return acc;
  }, [] as JSX.Element[][]);

  const groupedButtons = props.buttons?.reduce((acc, card, index, cards) => {
    if (index % 2 === 0) {
      acc.push(cards.slice(index, index + 2));
    }
    return acc;
  }, [] as JSX.Element[][]);

  return (
    <div className="container mt-4 px-0">
      <div className="row mb-4 gap-4">
        {groupedCards?.map((group, index) => {
          return (
            <div className="row mb-2 gap-4" key={index}>
              <div className="col-md">{group[0]}</div>
              <div className="col-md">{group[1]}</div>
            </div>
          );
        })}
      </div>
      <div className="row mb-4 gap-4">
        {groupedButtons?.map((group, index) => {
          return (
            <div className="row gap-6" key={index}>
              <div className="col-md">{group[0]}</div>
              <div className="col-md">{group[1]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardGrid;
